import { Component } from '@angular/core';
import { CustomButtonComponent } from '../../../../../shared/components/custom-button/custom-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-delete-account-dialog',
  standalone: true,
  imports: [TranslocoPipe, CustomButtonComponent],
  templateUrl: './delete-account-dialog.component.html',
  styleUrl: './delete-account-dialog.component.css'
})
export class DeleteAccountDialogComponent {
  modalDialogId: string = 'settings_modal_delete_account';
  private dialogResponsePromise!: (value: boolean) => void;

  openModal(): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement | null;
    if (modal) {
      modal.showModal();
      return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
    }
    return Promise.resolve(false);
  }

  closeModal(dialogResponse: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement | null;
    if (modal) {
      modal.close();
      if (this.dialogResponsePromise) {
        this.dialogResponsePromise(dialogResponse);
      }
    }
  }

}
